document.addEventListener('DOMContentLoaded', function () {
    if (!window.PERU_BALLOONS_CONFIG) return;

    const { distritosUrl, distritosDataUrl, formId, productHandle } = window.PERU_BALLOONS_CONFIG;

    /* ── Distrito ── */
    window.distritosData = distritosDataUrl;

    var distritoSelect = document.querySelector('[data-distrito-selector]');
    if (distritoSelect) {
        function loadDistritosData() {
            fetch(distritosUrl)
                .then(function (response) {
                    if (!response.ok) throw new Error('HTTP error! status: ' + response.status);
                    return response.json();
                })
                .then(function (data) {
                    window.distritosData = data;
                    populateDistritoSelect(data.distritos);
                })
                .catch(function (error) {
                    console.error('Error cargando datos de distritos:', error);
                });
        }

        function populateDistritoSelect(distritos) {
            if (!distritos) return;
            var distritosDisponibles = distritos
                .filter(function (d) { return d.disponible; })
                .sort(function (a, b) { return a.nombre.localeCompare(b.nombre); });

            distritosDisponibles.forEach(function (distrito) {
                var option = document.createElement('option');
                option.value = distrito.nombre;
                option.dataset.codigo = distrito.codigo;
                option.dataset.costo = distrito.costo;
                option.dataset.zona = distrito.zona;
                option.textContent = distrito.nombre + ' - S/ ' + distrito.costo.toFixed(2);
                distritoSelect.appendChild(option);
            });
        }

        distritoSelect.addEventListener('change', function (e) {
            var selectedOption = e.target.selectedOptions[0];

            if (!selectedOption.value) {
                window.selectedShipping = null;
                return;
            }

            var costo = parseFloat(selectedOption.dataset.costo);

            window.selectedShipping = {
                nombre: selectedOption.value,
                codigo: selectedOption.dataset.codigo,
                costo: costo,
                zona: selectedOption.dataset.zona,
                variantId: null
            };

            if (window.shippingVariantsCache) {
                var match = window.shippingVariantsCache.find(function (v) { return (v.price / 100) === costo; });
                if (match) window.selectedShipping.variantId = match.id;
            }

            document.dispatchEvent(new CustomEvent('distrito:changed', { detail: window.selectedShipping }));
        });

        fetch('/products/costo-de-envio.js')
            .then(function (r) { return r.json(); })
            .then(function (product) {
                window.shippingVariantsCache = product.variants;
                if (window.selectedShipping && window.selectedShipping.costo) {
                    var match = product.variants.find(function (v) { return (v.price / 100) === window.selectedShipping.costo; });
                    if (match) window.selectedShipping.variantId = match.id;
                }
            })
            .catch(function (err) { console.warn('Pre-cache envío falló:', err); });

        loadDistritosData();
    }

    /* ── Anticipación ── */
    var anticEl = document.querySelector('.pdp-anticipation__today');
    if (anticEl) {
        var wrap = anticEl.closest('.pdp-anticipation');
        var cutoff = wrap.getAttribute('data-cutoff') || '14:00';
        var tmpl = anticEl.querySelector('.pdp-anticipation__text').getAttribute('data-today-template');

        function updateCountdown() {
            var now = new Date();
            var parts = cutoff.split(':');
            var target = new Date(now);
            target.setHours(parseInt(parts[0], 10), parseInt(parts[1], 10), 0, 0);
            var diff = target - now;
            if (diff <= 0) {
                anticEl.querySelector('.pdp-anticipation__text').textContent = 'Pedido para mañana o días posteriores';
                return;
            }
            var h = Math.floor(diff / 3600000);
            var m = Math.floor((diff % 3600000) / 60000);
            var s = Math.floor((diff % 60000) / 1000);
            var str = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
            anticEl.querySelector('.pdp-anticipation__text').textContent = tmpl.replace('[countdown]', str);
        }
        updateCountdown();
        setInterval(updateCountdown, 1000);
    }

    /* ── Schedule ── */
    var schedEl = document.querySelector('.pdp-schedule');
    if (schedEl) {
        var anticipation = parseInt(schedEl.getAttribute('data-anticipation'), 10) || 0;
        var disabledDays = [];
        var dayMap = { mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6, sun: 0 };
        Object.keys(dayMap).forEach(function (d) {
            if (schedEl.getAttribute('data-disable-' + d) === 'true') disabledDays.push(dayMap[d]);
        });
        var excludedStr = schedEl.getAttribute('data-excluded-dates') || '';
        var excludedDates = excludedStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var rangesStr = schedEl.getAttribute('data-ranges') || '';
        var ranges = rangesStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);

        var dateInput = schedEl.querySelector('.pdp-schedule__date');
        var timeSelect = schedEl.querySelector('.pdp-schedule__time');

        function initFlatpickr() {
            if (typeof flatpickr === 'undefined') { requestAnimationFrame(initFlatpickr); return; }

            var minDate = new Date();
            minDate.setDate(minDate.getDate() + anticipation);

            flatpickr(dateInput, {
                locale: typeof flatpickr.l10ns !== 'undefined' && flatpickr.l10ns.es ? 'es' : 'default',
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'j F, Y',
                minDate: minDate,
                disable: [
                    function (date) { return disabledDays.indexOf(date.getDay()) !== -1; }
                ].concat(excludedDates),
                onChange: function (selectedDates) {
                    populateTimeSlots(selectedDates[0]);
                }
            });
        }

        function populateTimeSlots(selectedDate) {
            timeSelect.innerHTML = '<option value="" disabled selected>Elige un horario</option>';
            var now = new Date();
            var isToday = selectedDate && selectedDate.toDateString() === now.toDateString();

            ranges.forEach(function (range) {
                var parts = range.split('-');
                if (parts.length !== 2) return;
                var startStr = parts[0].trim();
                var endStr = parts[1].trim();
                var startH = parseInt(startStr.split(':')[0], 10);
                var startM = parseInt(startStr.split(':')[1] || '0', 10);

                if (isToday) {
                    var slotStart = new Date(now);
                    slotStart.setHours(startH, startM, 0, 0);
                    if (slotStart <= now) return;
                }

                var opt = document.createElement('option');
                opt.value = startStr + ' - ' + endStr;
                opt.textContent = startStr + ' - ' + endStr;
                timeSelect.appendChild(opt);
            });
        }

        initFlatpickr();
    }

    /* ── Dedicatoria ── */
    var dedCheck = document.querySelector('.pdp-dedication__check');
    if (dedCheck) {
        var dedField = document.querySelector('.pdp-dedication__field');
        var dedTextarea = document.querySelector('.pdp-dedication__textarea');
        var dedCounter = document.querySelector('.pdp-dedication__counter');
        var maxLen = parseInt(dedTextarea.getAttribute('maxlength'), 10) || 200;

        dedCheck.addEventListener('change', function () {
            dedField.hidden = !this.checked;
            if (!this.checked) { dedTextarea.value = ''; dedCounter.textContent = '0 / ' + maxLen; }
        });

        dedTextarea.addEventListener('input', function () {
            dedCounter.textContent = this.value.length + ' / ' + maxLen;
        });
    }

    /* ── Texto personalización (nombre y frase: contador por input) ── */
    document.querySelectorAll('[data-balloon-text-input]').forEach(function (input) {
        var max = parseInt(input.getAttribute('data-max-chars'), 10) || 50;
        var wrap = input.closest('.pdp-balloon-phrase__section');
        var counter = wrap ? wrap.querySelector('[data-balloon-text-counter]') : null;
        if (counter) {
            input.addEventListener('input', function () {
                counter.textContent = this.value.length + ' / ' + max;
            });
        }
    });

    /* ── Personalización con números (checkboxes 0-9, elegir 1 o 2) ── */
    /* Orden de selección: el valor enviado es un solo número (ej. 2 luego 0 → "20") */
    var personalizationBlocks = document.querySelectorAll('.pdp-balloon-phrase[data-activar-personalizacion="true"][data-personalizacion-cantidad]');
    personalizationBlocks.forEach(function (block) {
        var count = parseInt(block.getAttribute('data-personalizacion-cantidad'), 10);
        if (count !== 1 && count !== 2) return;
        var hiddenInput = block.querySelector('[data-personalization-value]');
        var checkboxes = block.querySelectorAll('[data-personalization-checkbox]');
        if (!hiddenInput || !checkboxes.length) return;
        var hintEl = block.querySelector('[data-personalization-hint]');
        var hintOne = hintEl ? (hintEl.getAttribute('data-hint-one') || 'Elige 1 número') : 'Elige 1 número';
        var hintTwo = hintEl ? (hintEl.getAttribute('data-hint-two') || 'Elige 2 números') : 'Elige 2 números';
        var successOne = hintEl ? (hintEl.getAttribute('data-success-one') || 'Tu elección fue [valor]') : 'Tu elección fue [valor]';
        var successTwo = hintEl ? (hintEl.getAttribute('data-success-two') || 'Tu elección fue [valor]') : 'Tu elección fue [valor]';

        var selectedOrder = [];
        var clearWrap = block.querySelector('[data-personalization-clear-wrap]');
        var clearBtn = block.querySelector('[data-personalization-clear]');

        function getCheckedElsInOrder() {
            var els = [];
            checkboxes.forEach(function (cb) { if (cb.checked) els.push(cb); });
            return els;
        }

        function syncSelectedOrderFromCheckboxes() {
            selectedOrder = [];
            checkboxes.forEach(function (cb) {
                if (cb.checked) selectedOrder.push(cb.value);
            });
        }

        function updateHiddenAndMessages() {
            var complete = selectedOrder.length === count;
            hiddenInput.value = selectedOrder.join('');
            block.classList.remove('pdp-field--error');
            if (hintEl) {
                if (complete) {
                    var template = count === 1 ? successOne : successTwo;
                    hintEl.textContent = template.replace('[valor]', selectedOrder.join(''));
                } else {
                    hintEl.textContent = count === 1 ? hintOne : hintTwo;
                }
            }
            if (clearWrap) clearWrap.hidden = !complete;
            checkboxes.forEach(function (cb) { cb.disabled = complete; });
            var numbersWrap = block.querySelector('[data-personalization-numbers]');
            if (numbersWrap) numbersWrap.classList.toggle('is-locked', complete);
        }

        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                checkboxes.forEach(function (cb) { cb.checked = false; });
                selectedOrder = [];
                updateHiddenAndMessages();
            });
        }

        checkboxes.forEach(function (cb) {
            cb.addEventListener('change', function () {
                if (this.checked) {
                    if (count === 1) {
                        checkboxes.forEach(function (other) { if (other !== cb) other.checked = false; });
                        selectedOrder = [this.value];
                    } else {
                        if (selectedOrder.length >= 2) {
                            var firstEl = block.querySelector('[data-personalization-checkbox][value="' + selectedOrder[0] + '"]');
                            if (firstEl) firstEl.checked = false;
                            selectedOrder.shift();
                        }
                        selectedOrder.push(this.value);
                    }
                } else {
                    selectedOrder = selectedOrder.filter(function (v) { return v !== this.value; }.bind(this));
                }
                updateHiddenAndMessages();
            });
        });
    });

    /* ── Validación ATC ── */
    var atcBtn = document.querySelector('.pdp-btn--atc');
    if (atcBtn) {
        function getWrap(el) {
            return el.closest('.pdp-schedule__col') ||
                el.closest('.pdp-balloon-phrase') ||
                el.closest('.pdp-dedication__field') ||
                el.closest('.pdp-dedication') ||
                el.closest('.pdp-recipient') ||
                el.closest('.pdp-distrito') ||
                el.parentElement;
        }

        atcBtn.addEventListener('click', function (e) {
            document.querySelectorAll('.pdp-field--error').forEach(function (el) {
                el.classList.remove('pdp-field--error');
            });

            var firstError = null;
            var personalizationBlocksToValidate = document.querySelectorAll('.pdp-balloon-phrase[data-personalizacion-cantidad="1"], .pdp-balloon-phrase[data-personalizacion-cantidad="2"]');
            personalizationBlocksToValidate.forEach(function (block) {
                var hiddenInput = block.querySelector('[data-personalization-value]');
                if (hiddenInput && !hiddenInput.value.trim()) {
                    block.classList.add('pdp-field--error');
                    if (!firstError) firstError = block;
                }
            });

            var fields = document.querySelectorAll('[form="' + formId + '"][required]');

            fields.forEach(function (f) {
                var empty = false;
                if (f.tagName === 'SELECT') empty = !f.value;
                else if (f.type === 'radio') {
                    var group = document.querySelectorAll('[form="' + formId + '"][name="' + f.name + '"]');
                    var checked = false;
                    group.forEach(function (r) { if (r.checked) checked = true; });
                    empty = !checked;
                } else if (f.type === 'checkbox') empty = !f.checked;
                else empty = !f.value.trim();

                if (empty) {
                    var wrap = getWrap(f);
                    if (wrap) wrap.classList.add('pdp-field--error');
                    if (!firstError) firstError = wrap || f;
                }
            });

            if (firstError) {
                e.preventDefault();
                e.stopImmediatePropagation();
                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return false;
            }
        }, true);

        document.addEventListener('change', function (ev) {
            if (ev.target.hasAttribute('required') || ev.target.type === 'radio') {
                var w = getWrap(ev.target); if (w) w.classList.remove('pdp-field--error');
            }
        });
        document.addEventListener('input', function (ev) {
            if (ev.target.hasAttribute('required')) {
                var w = getWrap(ev.target); if (w) w.classList.remove('pdp-field--error');
            }
        });
    }

    /* ── Agregar al carrito: spinner y «Agregando…» mientras product-form agrega (clase .loading) ── */
    var atcLoadingActive = false;
    if (atcBtn) {
        var atcText = atcBtn.querySelector('span');
        var atcLabel = '';
        new MutationObserver(function () {
            var loading = atcBtn.classList.contains('loading');
            // Con «Comprar ahora» el indicador se muestra en ese botón, no en este.
            if (loading && !atcLoadingActive && !document.querySelector('[data-pdp-buy-now].is-loading')) {
                atcLoadingActive = true;
                atcLabel = atcText ? atcText.textContent : '';
                atcBtn.classList.add('is-loading');
                atcBtn.setAttribute('aria-busy', 'true');
                if (atcText) atcText.textContent = atcBtn.getAttribute('data-loading-text') || atcLabel;
            } else if (!loading && atcLoadingActive) {
                atcLoadingActive = false;
                atcBtn.classList.remove('is-loading');
                atcBtn.setAttribute('aria-busy', 'false');
                if (atcText) atcText.textContent = atcLabel;
            }
        }).observe(atcBtn, { attributes: true, attributeFilter: ['class'] });
    }

    /* ── Comprar ahora: usa el mismo formulario (y su validación) y abre directo el paso del distrito ── */
    var buyNowBtn = document.querySelector('[data-pdp-buy-now]');
    if (buyNowBtn && atcBtn) {
        var buyNowPending = false;
        var buyNowTimer = null;

        var buyNowText = buyNowBtn.querySelector('[data-buy-now-text]');
        var buyNowLabel = buyNowText ? buyNowText.textContent : '';

        // Indicador de espera: spinner en lugar del carrito y «Agregando…»; el botón no cambia de tamaño.
        function setBuyNowLoading(loading) {
            buyNowBtn.classList.toggle('is-loading', loading);
            buyNowBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
            if (buyNowText) buyNowText.textContent = loading ? (buyNowText.getAttribute('data-loading-text') || buyNowLabel) : buyNowLabel;
        }

        function endBuyNow() {
            buyNowPending = false;
            clearTimeout(buyNowTimer);
            setBuyNowLoading(false);
        }

        // Se mantiene «Agregando…» hasta que se abre la hoja del distrito.
        function openDistrictStep() {
            var tries = 0;
            (function wait() {
                var drawer = document.querySelector('cart-drawer');
                var trigger = drawer && drawer.querySelector('[data-enova-minicart-checkout]');
                if (drawer && drawer.classList.contains('active') && trigger && !trigger.disabled) {
                    trigger.click();
                    setBuyNowLoading(false);
                    return;
                }
                if (++tries < 40) setTimeout(wait, 100);
                else setBuyNowLoading(false);
            })();
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
                if (!buyNowPending || !event || event.source !== 'product-form') return;
                buyNowPending = false;
                clearTimeout(buyNowTimer);
                openDistrictStep();
            });
            subscribe(PUB_SUB_EVENTS.cartError, function () {
                if (buyNowPending) endBuyNow();
            });
        }

        // El botón sigue la disponibilidad de la variante elegida
        new MutationObserver(function () {
            buyNowBtn.disabled = atcBtn.disabled;
        }).observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });

        buyNowBtn.addEventListener('click', function () {
            if (atcBtn.disabled || atcBtn.getAttribute('aria-disabled') === 'true') return;
            if (buyNowPending) return;
            buyNowPending = true;
            setBuyNowLoading(true);
            clearTimeout(buyNowTimer);
            buyNowTimer = setTimeout(endBuyNow, 8000);
            atcBtn.click();
            // Si faltan campos, la validación de arriba frena el envío y marca los errores.
            if (document.querySelector('.pdp-field--error')) endBuyNow();
        });
    }

    /* ── Recently Viewed ── */
    if (productHandle) {
        var key = 'recently-viewed';
        var max = 12;
        try {
            var items = JSON.parse(localStorage.getItem(key) || '[]');
            items = items.filter(function (h) { return h !== productHandle; });
            items.unshift(productHandle);
            if (items.length > max) items = items.slice(0, max);
            localStorage.setItem(key, JSON.stringify(items));
        } catch (e) { }
    }
});
